import React from 'react'
import { TextField } from 'react-aria-components'
import { tv } from 'tailwind-variants'
import { composeTailwindRenderProps, focusRing } from '../../utils'
import {
  Description,
  FieldError,
  Label,
  TextAreaInput,
  fieldBorderStyles,
} from './Field'
import { TextFieldProps } from './TextField'

const inputStyles = tv({
  extend: focusRing,
  base: 'border rounded-md',
  variants: {
    isFocused: fieldBorderStyles.variants.isFocusWithin,
    ...fieldBorderStyles.variants,
  },
})

export function TextArea({
  label,
  description,
  errorMessage,
  ...props
}: TextFieldProps) {
  return (
    <TextField
      {...props}
      className={composeTailwindRenderProps(
        props.className,
        'flex flex-col gap-1'
      )}
    >
      {label && <Label>{label}</Label>}
      <TextAreaInput className={inputStyles} />
      {description && <Description>{description}</Description>}
      <FieldError>{errorMessage}</FieldError>
    </TextField>
  )
}
